<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :flex="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-map />
      <o-section-header title="Tankstations" />
      <o-section class="u-flex__flexible c-welcome">
        <p class="u-center">
          <strong>Welkom bij Q8 Brusselsesteenweg</strong><br />
          Brusselsesteenweg 100<br />
          3000 Leuven
        </p>
        <p class="u-center">
          <o-loyalty-points image="/images/logo-smiles.png">
            <strong>Huidig saldo</strong><br />
            122 smiles
          </o-loyalty-points>
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Start tankbeurt" to="/sales/fuel/q8/fuel/pump" />
  </o-view>
</template>

<script>
import OLoyaltyPoints from '@/components/OLoyaltyPoints.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OLoyaltyPoints,
    OMap,
    OPayButton
  }
}
</script>

<style lang="scss">
.c-welcome {
  padding-top: 3.2rem;
}
</style>
